import { Box, Modal, Stack, TextField, Typography } from '@mui/material'
import ButtonComponent from '../../Components/ButtonComponent';
// import CustomFileUpload from '../../Components/CustomFileUpload/CustomFileUpload';
import { ChangeEvent, useMemo, useState } from 'react';
// import { fileToBase64 } from '../../Utils/fileUtils';
import useSnackbar from '../../Components/useSnackbar';
import emailjs from "emailjs-com";

interface Props{
    open:boolean;
    onClose:()=>void
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth:320,
    maxWidth: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p:4,
    maxHeight: '90vh',  
    overflowY: 'auto',  
  };

const ProofUploadForm = (props:Props) => {
    const {onClose,open} = props
    // const [selectedFile,setSelectedFile] = useState<null|File>(null)
    const [isLoading,setIsLoading] = useState(false)

    const [formData,setData] =useState({
        name:'',
        loan_account:'',
        phone:'',
        amount:'',
        utr:'',
        message:''
    })

    const {SnackbarComponent,errorAlert,successAlert} = useSnackbar()

    const handleChange =(event:ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)=>{
        const { name, value } = event.target;
        setData((prev) => {
          return { ...prev, [name]: value };
        });
    }

    // const handleDrop=(event: React.DragEvent<HTMLDivElement>)=>{
    //     event.preventDefault()
    //     setSelectedFile(event.dataTransfer.files?.length ?event.dataTransfer.files[0]:null )
    // }

    // const handleFileChange =(event: React.ChangeEvent<HTMLInputElement>)=>{
    //     setSelectedFile(event.target.files?.length ? event.target.files[0]:null)
    // }

    // const handleRemoveImage =()=>{
    //     setSelectedFile(null)
    // }

    // useEffect(()=>{
    //     if(selectedFile){
    //        (async()=>{
    //            const base64 = await fileToBase64(selectedFile)
    //        setData((prev)=>{
    //         return {
    //             ...prev,img_base64:base64
    //         }
    //        })
    //        })()
    //     }else{
    //         setData((prev)=>{
    //             return {
    //                 ...prev,img_base64:''
    //             }
    //            })
    //     }
    // },[selectedFile])

    const allDataExist = useMemo(()=>{
        if(formData.name && formData.amount && formData.utr && formData.loan_account && formData.phone){
            return true
        }
        return false
    },[formData.name , formData.amount , formData.utr , formData.loan_account , formData.phone])

    const onUpload =()=>{
        if(allDataExist){
            const templateParams = formData;
            setIsLoading(true)
            emailjs
              .send(
                process.env.REACT_APP_SERVICE_ID as string,
                process.env.REACT_APP_TEMPLATE_ID2 as string,
                templateParams,
                process.env.REACT_APP_PUBLIC_KEY
              )
              .then(
                (result) => {
                  console.log(result.text);
                  successAlert("Upload Successfully!")
                  setIsLoading(false)
                  onClose()
                },
                (error) => {
                  console.log(error.text);
                  errorAlert("Something went wrong")
                  setIsLoading(false)
                }
              );
          }
    }

  return (
    <>
    <Modal open={open} onClose={onClose}  sx={{overflowY:'scroll'}}>
        <Box sx={style} >
            <Stack gap={2}>
                <Typography variant='h5' sx={{fontWeight:600,textAlign:"center",textDecoration:"underline"}} >Upload Transaction Proof</Typography>
                <Box>
                <TextField
                        required
                        id="outlined-required"
                        label="Name"
                        defaultValue=""
                        name="name"
                        fullWidth
                        value={formData.name}
                        onChange={handleChange}
                      />
                </Box>
                <Box>
                <TextField
                        required
                        id="outlined-required"
                        label="Loan Account Number"
                        defaultValue=""
                        name="loan_account"
                        fullWidth
                        value={formData.loan_account}
                        onChange={handleChange}
                      />
                </Box>
                <Box>
                <TextField
                        required
                        id="outlined-required"
                        label="Phone No."
                        defaultValue=""
                        name="phone"
                        fullWidth
                        value={formData.phone}
                        onChange={handleChange}
                      />
                </Box>
                <Box>
                <TextField
                        required
                        id="outlined-required"
                        label="Amount"
                        defaultValue=""
                        name="amount"
                        fullWidth
                        value={formData.amount}
                        onChange={handleChange}
                      />
                </Box>
                <Box>
                <TextField
                        required
                        id="outlined-required"
                        label="UTR Number"
                        defaultValue=""
                        name="utr"
                        fullWidth
                        value={formData.utr}
                        onChange={handleChange}
                      />
                    {/* <CustomFileUpload handleDrop={handleDrop} handleFileChange={handleFileChange}  selectedFile={selectedFile} handleRemove={handleRemoveImage} /> */}
                </Box>
                <Box>
                <TextField
                        id="outlined-multiline-static"
                        required
                        label="Message"
                        multiline
                        rows={4}
                        defaultValue=""
                        sx={{ width: "100%" }}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                </Box>
                <ButtonComponent type='button' value='Submit' sx={{margin:"auto"}} onClick={onUpload} disabled={!allDataExist || isLoading} isLoading ={isLoading}/>
            </Stack>
        </Box>
    </Modal>
    <SnackbarComponent />
    </>
  )
}

export default ProofUploadForm